"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("../Button"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _Link = _interopRequireDefault(require("../Link"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _index = _interopRequireDefault(require("./index.style"));
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/anchor-is-valid */

const defaultCheckboxLabel = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "I agree to the"), /*#__PURE__*/_react.default.createElement(_Link.default, {
  component: "button",
  underline: "none"
}, "Terms and Conditions"));
const defaultTooltipLabel = /*#__PURE__*/_react.default.createElement(_Link.default, {
  component: "button",
  underline: "none"
}, "$6.00");
const PaymentFooter = _ref => {
  let {
    tooltipContent = /*#__PURE__*/_react.default.createElement(_Typography.default, null, "Content tooltip "),
    tooltipPlacement = 'top-end',
    tooltipLabel = defaultTooltipLabel,
    checkboxLabel = defaultCheckboxLabel,
    showTermsAndConditionsCheckBox,
    showTooltip,
    paymentSummaryLabel = 'Payments applied: ',
    submitCTA = 'Book Flight',
    disableSbumit,
    className,
    submitHandler = () => {},
    onChangeCheckBox = () => {},
    ...others
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_Footer.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.paymentFooter, className)
  }, others), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.termsWrapper
  }, showTermsAndConditionsCheckBox && /*#__PURE__*/_react.default.createElement(_core.FormGroup, null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      color: "primary",
      onChange: onChangeCheckBox
    }),
    label: /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: classes.checkboxLabel
    }, checkboxLabel)
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.summaryWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.tooltipWrapper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, paymentSummaryLabel), showTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    toolTipExtraClasses: {
      tooltip: classes.tooltip
    },
    style: {
      maxWidth: '500px'
    },
    element: tooltipLabel,
    content: tooltipContent,
    elementClassName: classes.element,
    tooltipProps: {
      placement: tooltipPlacement,
      PopperProps: {
        modifiers: {
          offset: {
            enabled: true,
            offset: "20, 20"
          }
        }
      }
    }
  }))), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    className: classes.submitButton,
    variant: "contained",
    disabled: disableSbumit,
    onClick: submitHandler
  }, submitCTA));
};
var _default = exports.default = PaymentFooter;